import { useEffect, useRef, useState } from "react";
import { MdOutlineCloudUpload } from "react-icons/md";
import { Button, Card, CardBody, CardHeader, CardTitle, Col, Row } from "reactstrap";
import Attachment from "../../../../components/Attachments";
import { del, get, post, postForm } from "../../../../utils/helpers/api";
import { useTranslation } from "react-i18next";

function AttachmentsSection({ objectData, objectType }) {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const [ attachments, setAttachments ] = useState([]);
  const [ selectedFiles, setSelectedFiles ] = useState([]);
  const [uploadLoading, setUploadLoading] = useState(false);

  useEffect(() => {
    if(objectData?.id) {
      getAttachments();
    }
  }, [objectData]);

  const getAttachments = async () => {
    setUploadLoading(true);
    
    const data = await get(`/crm/attachments/view/${objectType}/${objectData.id}`);
    if(data.success) {
      setAttachments(data.attachments);
    }
    setUploadLoading(false);
  }

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFiles(prev => [...prev, file]);
      uploadFile(file);
    }
  }

  const deleteAttachment = async (id) => {
    const data = await del('/crm/attachments/delete/' + id);
    if (data.success) getAttachments();
  };

  const renameAttachment = async (id, title) => {
    const data = await post(`/crm/attachments/update/${objectType}/` + id, { 
      attachment_title: title
    });

    if (data.success) getAttachments();
  };

  const uploadFile = async (file) => {
    setUploadLoading(true);

    const data = new FormData();
    data.append('attachment', file);

    Promise.resolve(postForm(`/crm/attachments/store/${objectType}/${objectData?.id}`, data))
    .then(data => {
      setUploadLoading(false);
      getAttachments();
    })
    .catch(error => {
      setUploadLoading(false);
    });
  }
  
  return(
    <Card className="mt-3" id="attachments-card">
      <CardHeader>
        <Row className="align-items-center">
          <Col md="9" xs="8">        
            <CardTitle tag="h5" className="mb-0 fw-bold py-1">{t('attachments.title')}</CardTitle>
          </Col>
          <Col md="3" xs="4" className="text-end">
            <Button color="dark" outline size="sm" className="d-inline-flex align-items-center" onClick={handleUploadClick}>
              <MdOutlineCloudUpload className="me-1" size={14} />
              {t('common.uploadFile')}
            </Button>
            <input 
              type="file" 
              className="d-none" 
              ref={fileInputRef} 
              onChange={handleFileChange}
            />
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        {attachments?.data?.length > 0 ? (
          attachments.data.map(attachment => (
            <Attachment
              key={attachment.id}
              attachment={attachment}
              onDelete={deleteAttachment}
              onRename={renameAttachment}
            />
          ))
        ) : (
          <p className="mb-0 text-center">
            {t('common.noData')}
          </p>
        )
        }
      </CardBody>
    </Card>
  );
}

export default AttachmentsSection;